<template>
	<div class="site">
		<Nav/>
		<div id="content" class="site-content">
			<div style="min-height: 380px;">
				<img src="../../assets/images/CRM-banner-new.jpg" style="object-fit: cover;width: 100%;height:380px;">
			</div>
			<div id="primary" class="content-area normal">
				<div id="contentHolder" style="transform: none;">
					<div class="rowContainer container-custom">
						<div class="row wrapper">
							<div class="col-xl-8 content">
								<div class="rt-sidebar-sapcer theiaStickySidebar">
									<div class="main-wrap">
										<div class="entry-thumbnail-area">
											<img :src="blog.firstPicture" style="max-width: 100%;height: auto;">
										</div>
										<div class="entry-header">
											<span class="entry-categories">				
												<router-link :to="`/category/${blog.category.name}/`">
													<span class="category-style" style="background:rgba(17, 17, 17,0.1)">
														<span class="category-color" style="color:#111111">
															{{ blog.category.name }}
														</span>
													</span>
												</router-link>
											</span>
											<h1 class="entry-title">{{ blog.title }}</h1>
											<ul class="entry-meta">
												<!-- <li class="item-author">by <a href="https://netsparks.online/author/admin/" title="Posts by admin" rel="author">admin</a></li> -->
												<!-- <li>{{formatDate(blog.updateTime)}}</li> -->
												<li><span class="comment-number">{{ blog.comments }}</span> Comments</li>
												<li><span class="meta-views meta-item"><span class="meta-views meta-item very-high">Views<span class="view-number"> {{ blog.views }}</span> </span> </span></li>
											</ul>
										</div>
										<div class="entry-content">
											<div v-html="blog.content"></div>
										</div>
										<div class="entry-footer">
											<div class="entry-footer-meta">
												<div class="post-share">
													<h4 class="meta-title">Share This Post:</h4>			
													<div class="share-links ">
														<a href="" rel="external" target="_blank" class="facebook-f-share-button large-share-button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path fill="#ffffff" d="M80 299.3V512H196V299.3h86.5l18-97.8H196V166.9c0-51.7 20.3-71.5 72.7-71.5c16.3 0 29.4 .4 37 1.2V7.9C291.4 4 256.4 0 236.2 0C129.3 0 80 50.5 80 159.4v42.1H14v97.8H80z"/></svg></a>
														<a href="" rel="external" target="_blank" class="x-twitter-share-button large-share-button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path fill="#ffffff" d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"/></svg></a>
														<a href="" rel="external" target="_blank" class="youtube-share-button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path fill="#ffffff" d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"/></svg></a>
														<a href="" rel="external" target="_blank" class="linkedin-in-share-button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path fill="#ffffff" d="M100.3 448H7.4V148.9h92.9zM53.8 108.1C24.1 108.1 0 83.5 0 53.8a53.8 53.8 0 0 1 107.6 0c0 29.7-24.1 54.3-53.8 54.3zM447.9 448h-92.7V302.4c0-34.7-.7-79.2-48.3-79.2-48.3 0-55.7 37.7-55.7 76.7V448h-92.8V148.9h89.1v40.8h1.3c12.4-23.5 42.7-48.3 87.9-48.3 94 0 111.3 61.9 111.3 142.3V448z"/></svg></a>
														<a href="" rel="external" target="_blank" class="pinterest-p-share-button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path fill="#ffffff" d="M204 6.5C101.4 6.5 0 74.9 0 185.6 0 256 39.6 296 63.6 296c9.9 0 15.6-27.6 15.6-35.4 0-9.3-23.7-29.1-23.7-67.8 0-80.4 61.2-137.4 140.4-137.4 68.1 0 118.5 38.7 118.5 109.8 0 53.1-21.3 152.7-90.3 152.7-24.9 0-46.2-18-46.2-43.8 0-37.8 26.4-74.4 26.4-113.4 0-66.2-93.9-54.2-93.9 25.8 0 16.8 2.1 35.4 9.6 50.7-13.8 59.4-42 147.9-42 209.1 0 18.9 2.7 37.5 4.5 56.4 3.4 3.8 1.7 3.4 6.9 1.5 50.4-69 48.6-82.5 71.4-172.8 12.3 23.4 44.1 36 69.3 36 106.2 0 153.9-103.5 153.9-196.8C384 71.3 298.2 6.5 204 6.5z"/></svg></a>			
													</div>
												</div>
											</div>
										</div>
										<div class="rtrs-review-wrap  rtrs-review-post-type-post rtrs-review-sc">
											<div class="rtrs-summary-3">
												<div class="rtrs-rating-summary">
													<div class="rtrs-rating-item grid-span-2">
														<ul class="rtrs-rating-category">
															<li>
																<label>Quality</label>
																<el-rate
																	v-model="blog.rate"
																	disabled
																	show-score
																	text-color="#000"
																	score-template="{value}/5">
																</el-rate>
															</li>
															<li>
																<label>Price</label>
																<el-rate
																	v-model="blog.rate"
																	disabled
																	show-score
																	text-color="#000"
																	score-template="{value}/5">
																</el-rate>
															</li>
															<li>
																<label>Service</label>
																<el-rate
																	v-model="blog.rate"
																	disabled
																	show-score
																	text-color="#000"
																	score-template="{value}/5">
																</el-rate>
															</li>
															
														</ul>
													</div> 
													
													<div class="rtrs-rating-item">
														<div class="rtrs-rating-overall">
															<div class="rating-percent">{{blog.rate}}</div>
															<div class="rating-text">OVERALL</div>
															<el-rate
																v-model="blog.rate"
																disabled
																show-score
																text-color="#000"
																score-template=""
																style="margin-bottom: 6px;">
															</el-rate>
															<p>
																Based on {{ commentCount }} ratings
															</p>
														</div>
													</div>
												</div>
											</div>
											<div class="rtrs-sorting-bar">
												<h3 class="rtrs-sorting-title"> 
													Reviewed by {{ commentCount }} users			
												</h3>
												<div class="rtrs-sorting-select">
													<div>
														<label><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path fill="#161f38" d="M137.4 41.4c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8L32 224c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128zm0 429.3l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8l256 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128c-12.5 12.5-32.8 12.5-45.3 0z"/></svg>
														 Sort:</label> 
														<select class="rtrs_review_filter rtrs-sort-filter" name="rtrs_review_sort_filter" data-type="sort">
															<option value="all">All Review</option>  
															<option value="top_rated">Top Rated</option>
															<option value="low_rated">Low Rated</option>
															<option value="latest_first">Latest First</option> 
															<option value="oldest_first">Oldest First</option>  
														</select>
													</div>
													<div>
														<label><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path fill="#161f38" d="M3.9 54.9C10.5 40.9 24.5 32 40 32l432 0c15.5 0 29.5 8.9 36.1 22.9s4.6 30.5-5.2 42.5L320 320.9 320 448c0 12.1-6.8 23.2-17.7 28.6s-23.8 4.3-33.5-3l-64-48c-8.1-6-12.8-15.5-12.8-25.6l0-79.1L9 97.3C-.7 85.4-2.8 68.8 3.9 54.9z"/></svg>
														 Filter:</label> 
														<select class="rtrs_review_filter" name="rtrs_review_rating_filter" data-type="rating">
															<option value="">All Star</option>   
															<option value="5">5 Star</option>  
															<option value="4">4 Star</option>  
															<option value="3">3 Star</option>  
															<option value="2">2 Star</option>  
															<option value="1">1 Star</option>  
														</select>
													</div>
												</div>
											</div>
											<div id="respond" class="comment-respond rtrs-review-form">
												<h2 id="reply-title" class="rtrs-form-title">Leave feedback about this <small><a rel="nofollow" id="cancel-comment-reply-link" style="display:none;">Cancel Reply</a></small></h2>
												<el-form :inline="true" :model="commentForm" :rules="formRules" ref="formRef" size="small">
													<el-input :class="'textarea'" type="textarea" :rows="5" v-model="commentForm.content" placeholder="Write your review* "
														maxlength="250" show-word-limit :validate-event="false"></el-input>
													<el-input v-model="commentForm.nickname" placeholder="Name*" :validate-event="false">
															<!-- <i slot="prefix" class="el-input__icon el-icon-user"></i> -->
													</el-input>
														<!-- <el-popover ref="emailPopover" placement="bottom" trigger="focus"></el-popover> -->
													<el-input style="margin-top: 15px;" v-model="commentForm.email" placeholder="Email*" :validate-event="false">
															<!-- <i slot="prefix" class="el-input__icon el-icon-message"></i> -->
													</el-input>
													<div class="rtrs-form-group rtrs-hide-reply">
														<ul class="rtrs-rating-category" style="grid-template-columns: repeat(1, 270px);">
															<li>
																<div class="rtrs-category-text">Quality</div>
																<div class="rtrs-rating-container">
																	<el-rate
																		v-model="rateQuality"
																		text-color="#ff9900"
																		score-template="">
																	</el-rate>
																</div>
															</li>
															<li>
																<div class="rtrs-category-text">Price</div>
																<div class="rtrs-rating-container">
																	<el-rate
																		v-model="ratePrice"
																		text-color="#ff9900"
																		score-template="">
																	</el-rate>
																</div>
															</li>
															<li>
																<div class="rtrs-category-text">Service</div>
																<div class="rtrs-rating-container">
																	<el-rate
																		v-model="rateService"
																		text-color="#ff9900"
																		score-template="">
																	</el-rate>
																</div>
															</li>
														</ul>
													</div>            
													<div class="rtrs-form-group rtrs-hide-reply">
														<div class="rtrs-feedback-input">
															<div class="rtrs-input-item rtrs-pros">
																<h3 class="rtrs-input-title">
																	<span class="item-icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path fill="#ffffff" d="M323.8 34.8c-38.2-10.9-78.1 11.2-89 49.4l-5.7 20c-3.7 13-10.4 25-19.5 35l-51.3 56.4c-8.9 9.8-8.2 25 1.6 33.9s25 8.2 33.9-1.6l51.3-56.4c14.1-15.5 24.4-34 30.1-54.1l5.7-20c3.6-12.7 16.9-20.1 29.7-16.5s20.1 16.9 16.5 29.7l-5.7 20c-5.7 19.9-14.7 38.7-26.6 55.5c-5.2 7.3-5.8 16.9-1.7 24.9s12.3 13 21.3 13L448 224c8.8 0 16 7.2 16 16c0 6.8-4.3 12.7-10.4 15c-7.4 2.8-13 9-14.9 16.7s.1 15.8 5.3 21.7c2.5 2.8 4 6.5 4 10.6c0 7.8-5.6 14.3-13 15.7c-8.2 1.6-15.1 7.3-18 15.2s-1.6 16.7 3.6 23.3c2.1 2.7 3.4 6.1 3.4 9.9c0 6.7-4.2 12.6-10.2 14.9c-11.5 4.5-17.7 16.9-14.4 28.8c.4 1.3 .6 2.8 .6 4.3c0 8.8-7.2 16-16 16l-97.5 0c-12.6 0-25-3.7-35.5-10.7l-61.7-41.1c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l61.7 41.1c18.4 12.3 40 18.8 62.1 18.8l97.5 0c34.7 0 62.9-27.6 64-62c14.6-11.7 24-29.7 24-50c0-4.5-.5-8.8-1.3-13c15.4-11.7 25.3-30.2 25.3-51c0-6.5-1-12.8-2.8-18.7C504.8 273.7 512 257.7 512 240c0-35.3-28.6-64-64-64l-92.3 0c4.7-10.4 8.7-21.2 11.8-32.2l5.7-20c10.9-38.2-11.2-78.1-49.4-89zM32 192c-17.7 0-32 14.3-32 32L0 448c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-224c0-17.7-14.3-32-32-32l-64 0z"/></svg></span>
																	<span class="item-text">PROS</span>
																</h3>
																<div class="rtrs-input-filed" v-for="(field, index) in prosField" :key="index">
																	<span class="rtrs-remove-btn"  @click="removeProsField(index)" >+</span>
																	<input v-model="field.value" type="text" class="form-control" name="rt_pros[]" placeholder="Write here!">
																</div>
																<div class="rtrs-field-add" @click="addProsField" v-if="showProsAdd"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path fill="#646464" d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z"/></svg>Add Field</div>
															</div>
															<div class="rtrs-input-item rtrs-cons">
																<h3 class="rtrs-input-title">
																	<span class="item-icon unlike-icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path fill="#ffffff" d="M323.8 477.2c-38.2 10.9-78.1-11.2-89-49.4l-5.7-20c-3.7-13-10.4-25-19.5-35l-51.3-56.4c-8.9-9.8-8.2-25 1.6-33.9s25-8.2 33.9 1.6l51.3 56.4c14.1 15.5 24.4 34 30.1 54.1l5.7 20c3.6 12.7 16.9 20.1 29.7 16.5s20.1-16.9 16.5-29.7l-5.7-20c-5.7-19.9-14.7-38.7-26.6-55.5c-5.2-7.3-5.8-16.9-1.7-24.9s12.3-13 21.3-13L448 288c8.8 0 16-7.2 16-16c0-6.8-4.3-12.7-10.4-15c-7.4-2.8-13-9-14.9-16.7s.1-15.8 5.3-21.7c2.5-2.8 4-6.5 4-10.6c0-7.8-5.6-14.3-13-15.7c-8.2-1.6-15.1-7.3-18-15.2s-1.6-16.7 3.6-23.3c2.1-2.7 3.4-6.1 3.4-9.9c0-6.7-4.2-12.6-10.2-14.9c-11.5-4.5-17.7-16.9-14.4-28.8c.4-1.3 .6-2.8 .6-4.3c0-8.8-7.2-16-16-16l-97.5 0c-12.6 0-25 3.7-35.5 10.7l-61.7 41.1c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l61.7-41.1c18.4-12.3 40-18.8 62.1-18.8L384 32c34.7 0 62.9 27.6 64 62c14.6 11.7 24 29.7 24 50c0 4.5-.5 8.8-1.3 13c15.4 11.7 25.3 30.2 25.3 51c0 6.5-1 12.8-2.8 18.7C504.8 238.3 512 254.3 512 272c0 35.3-28.6 64-64 64l-92.3 0c4.7 10.4 8.7 21.2 11.8 32.2l5.7 20c10.9 38.2-11.2 78.1-49.4 89zM32 384c-17.7 0-32-14.3-32-32L0 128c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 224c0 17.7-14.3 32-32 32l-64 0z"/></svg></span>
																	<span class="item-text">CONS</span>
																</h3>
																<div class="rtrs-input-filed" v-for="(field, index) in consField" :key="index">
																	<span class="rtrs-remove-btn" @click="removeConsField(index)">+</span>
																	<input v-model="field.value" type="text" class="form-control" name="rt_cons[]" placeholder="Write here!">
																</div>
																<div class="rtrs-field-add" @click="addConsField" v-if="showConsAdd"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path fill="#646464" d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z"/></svg>Add Field</div>
															</div>
														</div>
													</div>
													<div class="rtrs-form-group">
														<el-button name="submit_btn" type="submit" id="submit" class="rtrs-submit-btn rtrs-review-submit" v-throttle="[postForm,`click`,3000]">Submit Review</el-button>
														<input type="hidden" name="comment_post_ID" value="7242" id="comment_post_ID">
														<input type="hidden" name="comment_parent" id="comment_parent" value="0">
													</div>
												</el-form>
											</div>
											<div class="rtrs-review-box">
												<ul class="rtrs-review-list">
													<li class="review even thread-even depth-1  rtrs-main-review" v-for="comment in reverseComments"> 
														<div class="rtrs-each-review  "> 
															<div class="rtrs-review-imgholder">
																<img :src="comment.avatar" alt="" style="height: 70px;width: 70px;">
															</div>
															<div class="rtrs-review-body"> 
																<ul class="rtrs-review-meta">
																	<li class="rtrs-review-rating">
																		<el-rate 
																			v-model="comment.rate"
																			disabled
																			text-color="#ff9900"
																			score-template="">
																		</el-rate>
																	</li>
																	<li class="rtrs-author-link">by: 
																		{{ comment.nickname }} <i class="rtrs-verified-author"></i>
																	</li>  
																	<li class="rtrs-review-date"><i class="rtrs-calendar"></i> 
																		{{ formatTime(comment.createTime) }}					</li>
																	<li style="float:right;"><a @click="confirmDelete(comment)"><u style="cursor:pointer;">Delete</u></a></li>
																</ul>
																<p>{{ comment.content }}</p>
																<p><small class="comment-author">Comment by: {{ comment.nickname }} ({{ formatTime(comment.createTime) }})</small><br><small class="post-title"><i>Product: {{ blog.title }}</i></small></p>
																<div class="rtrs-review-feedback" v-if="comment.pros"> 
																	<div class="rtrs-feedback-box rtrs-like-feedback">
																	<h3 class="rtrs-feedback-title">
																		<span class="item-icon like-icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path fill="#ffffff" d="M323.8 34.8c-38.2-10.9-78.1 11.2-89 49.4l-5.7 20c-3.7 13-10.4 25-19.5 35l-51.3 56.4c-8.9 9.8-8.2 25 1.6 33.9s25 8.2 33.9-1.6l51.3-56.4c14.1-15.5 24.4-34 30.1-54.1l5.7-20c3.6-12.7 16.9-20.1 29.7-16.5s20.1 16.9 16.5 29.7l-5.7 20c-5.7 19.9-14.7 38.7-26.6 55.5c-5.2 7.3-5.8 16.9-1.7 24.9s12.3 13 21.3 13L448 224c8.8 0 16 7.2 16 16c0 6.8-4.3 12.7-10.4 15c-7.4 2.8-13 9-14.9 16.7s.1 15.8 5.3 21.7c2.5 2.8 4 6.5 4 10.6c0 7.8-5.6 14.3-13 15.7c-8.2 1.6-15.1 7.3-18 15.2s-1.6 16.7 3.6 23.3c2.1 2.7 3.4 6.1 3.4 9.9c0 6.7-4.2 12.6-10.2 14.9c-11.5 4.5-17.7 16.9-14.4 28.8c.4 1.3 .6 2.8 .6 4.3c0 8.8-7.2 16-16 16l-97.5 0c-12.6 0-25-3.7-35.5-10.7l-61.7-41.1c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l61.7 41.1c18.4 12.3 40 18.8 62.1 18.8l97.5 0c34.7 0 62.9-27.6 64-62c14.6-11.7 24-29.7 24-50c0-4.5-.5-8.8-1.3-13c15.4-11.7 25.3-30.2 25.3-51c0-6.5-1-12.8-2.8-18.7C504.8 273.7 512 257.7 512 240c0-35.3-28.6-64-64-64l-92.3 0c4.7-10.4 8.7-21.2 11.8-32.2l5.7-20c10.9-38.2-11.2-78.1-49.4-89zM32 192c-17.7 0-32 14.3-32 32L0 448c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-224c0-17.7-14.3-32-32-32l-64 0z"/></svg></span>
																		<span class="item-text">PROS</span>
																	</h3>
																	<ul class="rtrs-feedback-list">
																		<li v-for="(pro, index) in comment.pros.split(',')" :key="index">
																			<svg t="1741849863846" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2652" width="256" height="256"><path d="M843.693959 293.609061 425.255869 712.056362 186.145026 472.947566 66.579883 592.504522 425.255869 951.165158 963.260126 413.174204Z" p-id="2653" fill="#000000"></path></svg>
																			{{ pro }}
																		</li>
																	</ul>
																</div>
																	<div class="rtrs-feedback-box rtrs-unlike-feedback" v-if="comment.cons">
																	<h3 class="rtrs-feedback-title">
																		<span class="item-icon unlike-icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path fill="#ffffff" d="M323.8 477.2c-38.2 10.9-78.1-11.2-89-49.4l-5.7-20c-3.7-13-10.4-25-19.5-35l-51.3-56.4c-8.9-9.8-8.2-25 1.6-33.9s25-8.2 33.9 1.6l51.3 56.4c14.1 15.5 24.4 34 30.1 54.1l5.7 20c3.6 12.7 16.9 20.1 29.7 16.5s20.1-16.9 16.5-29.7l-5.7-20c-5.7-19.9-14.7-38.7-26.6-55.5c-5.2-7.3-5.8-16.9-1.7-24.9s12.3-13 21.3-13L448 288c8.8 0 16-7.2 16-16c0-6.8-4.3-12.7-10.4-15c-7.4-2.8-13-9-14.9-16.7s.1-15.8 5.3-21.7c2.5-2.8 4-6.5 4-10.6c0-7.8-5.6-14.3-13-15.7c-8.2-1.6-15.1-7.3-18-15.2s-1.6-16.7 3.6-23.3c2.1-2.7 3.4-6.1 3.4-9.9c0-6.7-4.2-12.6-10.2-14.9c-11.5-4.5-17.7-16.9-14.4-28.8c.4-1.3 .6-2.8 .6-4.3c0-8.8-7.2-16-16-16l-97.5 0c-12.6 0-25 3.7-35.5 10.7l-61.7 41.1c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l61.7-41.1c18.4-12.3 40-18.8 62.1-18.8L384 32c34.7 0 62.9 27.6 64 62c14.6 11.7 24 29.7 24 50c0 4.5-.5 8.8-1.3 13c15.4 11.7 25.3 30.2 25.3 51c0 6.5-1 12.8-2.8 18.7C504.8 238.3 512 254.3 512 272c0 35.3-28.6 64-64 64l-92.3 0c4.7 10.4 8.7 21.2 11.8 32.2l5.7 20c10.9 38.2-11.2 78.1-49.4 89zM32 384c-17.7 0-32-14.3-32-32L0 128c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 224c0 17.7-14.3 32-32 32l-64 0z"/></svg></span>
																		<span class="item-text">CONS</span>
																	</h3>
																	<ul class="rtrs-feedback-list">
																		<li v-for="(con, index) in comment.cons.split(',')" :key="index">
																			<svg t="1741849863846" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2652" width="256" height="256"><path d="M843.693959 293.609061 425.255869 712.056362 186.145026 472.947566 66.579883 592.504522 425.255869 951.165158 963.260126 413.174204Z" p-id="2653" fill="#000000"></path></svg>
																			{{ con }}
																		</li>
																	</ul>
																</div>
																</div>
																<div class="rtrs-action-area"></div> 
															</div>
														</div>
													</li>
												</ul>
											</div>
											<div style="margin: 10px 0 20px;padding: 5px 1px;text-align: right;order:4;">
												<el-pagination
													:page-size="10"
													@current-change="handleCurrentChange" 
													:current-page="commentQuery.pageNum" 
													:page-count="commentTotalPage"
													background
													layout="prev, pager, next"
													:total="commentCount">
												</el-pagination>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="col-xl-4 mx-auto fixed-bar-coloum sidebar" style="position: relative; overflow: visible; box-sizing: border-box; min-height: 1px;">
								<MainSidebar></MainSidebar>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<el-dialog
			title=""
			:visible.sync="dialogVisible"
			width="80%"
			:before-close="handleClose"
			top="40vh"
			:show-close="false"
			>
			<!-- :before-close="handleClose" -->
			<div style="display: flex;flex-direction: column;">
				<span style="font-size: 16px;">Product Name: {{ blog.title }}</span>
				<span style="font-size: 16px;margin-top: 5px;">Delete Comment: {{ commentDetail.content }}</span>
				<span style="font-size: 16px;margin-top: 5px;margin-bottom: 20px;">Delete Date: {{ formattedDate }}</span>
				<span slot="footer" class="dialog-footer">
					<el-button type="danger" @click="dialogVisible = false" size="mini" round style="color: #fff;width:100px;">返回</el-button>
				</span>
			</div>
		</el-dialog>
		<Foot></Foot>
		<!-- <div class="ui padded attached segment m-padded-tb-large">
			<div class="ui large red right corner label" v-if="blog.top">
				<i class="arrow alternate circle up icon"></i>
			</div>
			<div class="ui middle aligned mobile reversed stackable">
				<div class="ui grid m-margin-lr">
				
					<div class="row m-padded-tb-small">
						<h2 class="ui header m-center">{{ blog.title }}</h2>
					</div>
			
					<div class="row m-padded-tb-small">
						<div class="ui horizontal link list m-center">
							<div class="item m-datetime">
								<i class="small calendar icon"></i><span>{{ blog.createTime | dateFormat('YYYY-MM-DD') }}</span>
							</div>
							<div class="item m-views">
								<i class="el-icon-s-data"></i><span>{{ blog.views }}</span>
							</div>
							<div class="item m-common-gray">
								<i class="el-icon-s-comment"></i><span>123</span>
							</div>
							<a class="item m-common-gray" @click.prevent="bigFontSize=!bigFontSize">
								<div data-inverted="" data-tooltip="点击切换字体大小" data-position="top center">
									<i class="font icon"></i>
								</div>
							</a>
							<a class="item m-common-gray" @click.prevent="changeFocusMode">
								<div data-inverted="" data-tooltip="专注模式" data-position="top center">
									<i class="book icon"></i>
								</div>
							</a>
						</div>
					</div>
			
					<router-link :to="`/category/${blog.category.name}`" class="ui orange large ribbon label" v-if="blog.category">
						<i class="small folder open icon"></i><span class="m-text-500">{{ blog.category.name }}</span>
					</router-link>
			
					<div class="typo js-toc-content m-padded-tb-small line-numbers match-braces rainbow-braces" v-viewer :class="{'m-big-fontsize':bigFontSize}" v-html="blog.content"></div>
					
					<div style="margin: 2em auto">
						<el-popover placement="top" width="220" trigger="click" v-if="blog.appreciation">
							<div class="ui orange basic label" style="width: 100%">
								<div class="image">
									<div style="font-size: 12px;text-align: center;margin-bottom: 5px;">一毛是鼓励</div>
									<img :src="$store.state.siteInfo.reward" alt="" class="ui rounded bordered image" style="width: 100%">
									<div style="font-size: 12px;text-align: center;margin-top: 5px;">一块是真爱</div>
								</div>
							</div>
						<el-button slot="reference" class="ui orange inverted circular button m-text-500">赞赏</el-button>
						</el-popover>
					</div>
			
					<el-divider></el-divider>
			
					<div class="row m-padded-tb-no">
						<div class="column m-padding-left-no">
							<router-link :to="`/tag/${tag.name}`" class="ui tag label m-text-500 m-margin-small" :class="tag.color" v-for="(tag,index) in blog.tags" :key="index">{{ tag.name }}</router-link>
						</div>
					</div>
				</div>
			</div>
		</div>
		<el-backtop style="box-shadow: none;background: none;">
			<img src="/img/paper-plane.png" style="width: 40px;height: 40px;z-index: 999999;">
		</el-backtop>
	
		<div class="ui attached positive message">
			<ul class="list">
			
				<li>最后修改：{{ blog.updateTime | dateFormat('YYYY-MM-DD HH:mm') }}</li>
				<li>如果你觉得我的文章不错，不妨鼓励我继续写作。</li>
			</ul>
		</div>

		<div class="ui bottom teal attached segment threaded comments">
			<CommentList :page="0" :blogId="blogId" v-if="blog.commentEnabled"/>
			<h3 class="ui header" v-else>评论已关闭</h3>
		</div> -->
	</div>
</template>

<script>
	import {getBlogById} from "@/api/blog";
	import CommentList from "@/components/comment/CommentList";
	import Nav from "@/components/index/Nav";
	import Foot from "@/components/index/Foot";
	import {mapState} from "vuex";
	import {SET_FOCUS_MODE, SET_IS_BLOG_RENDER_COMPLETE} from '@/store/mutations-types';
	import {SET_COMMENT_QUERY_PAGE, SET_COMMENT_QUERY_BLOG_ID, SET_COMMENT_QUERY_PAGE_NUM, SET_PARENT_COMMENT_ID} from "@/store/mutations-types";
	import {getSearchBlogList,getReviewsBlog} from "@/api/blog";
	import {getBlogsCategory} from "@/api/category";
	import {checkEmail} from "@/common/reg";
	import {updatePublished} from '@/api/comment'
	import MainSidebar from "@/components/sidebar/MainSidebar";
	import axios from '@/plugins/axios'

	export default {
		props: ['id'], 
		name: "Blog",
		components: {CommentList,Nav,Foot,MainSidebar},
		data() {
			return {
				blog: {},
				bigFontSize: false,
				categoryList:[],
				ratePrice: 5,
				rateQuality: 5,
				rateService: 5,
				message: '',
				name: '',
				email: '',
				formRules: {
					nickname: [
						{required: true, message: '请输入评论昵称'},
						{max: 18, message: '昵称不可多于15个字符'}
					],
					email: [
						{required: true, message: '请输入评论邮箱'},
						{validator: checkEmail}
					],
				},
				page: 1,
				prosField: [],
				consField: [],
				showProsAdd: true,
				showConsAdd: true,
				dialogVisible: false,
				commentDetail: {}
				
			}
		},
		computed: {
			...mapState(['siteInfo', 'focusMode','parentCommentId', 'commentForm', 'commentQuery','comments','commentCount','commentTotalPage']),
			blogId() {
				return parseInt(this.id)
			},
			reverseComments() {
				return Array.isArray(this.comments) ? [...this.comments].reverse() : [];
			},
			formattedDate(){
				const now = new Date();
				const year = now.getFullYear();
				const month = (now.getMonth() + 1).toString().padStart(2, '0');
				const date = now.getDate().toString().padStart(2, '0');
				const hours = now.getHours().toString().padStart(2, '0');
				const minutes = now.getMinutes().toString().padStart(2, '0');
				const seconds = now.getSeconds().toString().padStart(2, '0');
				return `${year}-${month}-${date} ${hours}:${minutes}:${seconds}`;
			}
		},
		beforeRouteEnter(to, from, next) {
			//路由到博客文章页面之前，应将文章的渲染完成状态置为 false
			next(vm => {
				// 当 beforeRouteEnter 钩子执行前，组件实例尚未创建
				// vm 就是当前组件的实例，可以在 next 方法中把 vm 当做 this用
				vm.$store.commit(SET_IS_BLOG_RENDER_COMPLETE, false)
			})
		},
		beforeRouteLeave(to, from, next) {
			this.$store.commit(SET_FOCUS_MODE, false)
			// 从文章页面路由到其它页面时，销毁当前组件的同时，要销毁tocbot实例
			// 否则tocbot一直在监听页面滚动事件，而文章页面的锚点已经不存在了，会报"Uncaught TypeError: Cannot read property 'className' of null"
			tocbot.destroy()
			next()
		},
		beforeRouteUpdate(to, from, next) {
			console.log(to)
			// 一般有两种情况会触发这个钩子
			// ①当前文章页面跳转到其它文章页面
			// ②点击目录跳转锚点时，路由hash值会改变，导致当前页面会重新加载，这种情况是不希望出现的
			// 在路由 beforeRouteUpdate 中判断路径是否改变
			// 如果跳转到其它页面，to.path!==from.path 就放行 next()
			// 如果是跳转锚点，path不会改变，hash会改变，to.path===from.path, to.hash!==from.path 不放行路由跳转，就能让锚点正常跳转
			if (to.path !== from.path) {
				this.$store.commit(SET_FOCUS_MODE, false);
				this.page = 1;
				const fetchBlogData = async () => {
					try {
						const blogId = await this.getBlogIdByTitle(to.params.blogTitle);
						await this.getBlog(blogId);
						this.init(blogId, 1);
						this.$store.commit(SET_IS_BLOG_RENDER_COMPLETE, false);
						next();
					} catch (error) {
						console.error("获取博客文章失败:", error);
						next(false); // 如果获取失败，则中止导航
					}
				};
				fetchBlogData();
			} else {
				next();
			}
		},
		created() {
			this.commentQuery.pageNum = 1
			this.getBlog(this.id)
			this.init(this.id,this.page)
		},
		methods: {
			getBlogIdByTitle(title) {
				return axios({
						url: 'getBlogIdByTitle',
						method: 'Get',
						params: {
							title
						}
					})
				.then(response => {
					// console.log(response)
					if (response.data!=null) {
					return response.data; 
					} else {
						Message.error("There is no relevant article!")
					}
				})
				.catch(error => {
					console.error("获取文章ID失败：", error);
					throw error;
				});
			},
			removeProsField(index) {
				this.prosField.splice(index, 1);
				if (this.prosField.length < 3) {
					this.showProsAdd = true
				}
			},
			removeConsField(index) {
				this.consField.splice(index, 1);
				if (this.consField.length < 3) {
					this.showConsAdd = true
				}
			},
			addConsField() {
				console.log(this.consField)
				if (this.consField.length < 3) {
					this.consField.push({ value: '' });
				}
				if(this.consField.length == 3){
					this.showConsAdd = false
				}
			},
			addProsField() {
				if (this.prosField.length < 3) {
					this.prosField.push({ value: '' });
				} 
				if(this.prosField.length == 3){
					this.showProsAdd = false
				}
			},
			handleClose(done) {
				this.commentDetail = {}
			},
			confirmDelete(item) {
				const isConfirmed = confirm('Are you sure you want to delete this comment?');
				if (isConfirmed) {
					updatePublished(item.id, 0).then(res => {
						// this.msgSuccess('Delete Success');
						this.commentDetail = item
						console.log(this.commentDetail)
						this.dialogVisible = true
						this.getBlog(this.id)
						this.init(this.id,this.page)
					}).catch(() => {
						this.msgError("请求失败")
					})
				} else {
					console.log('Deletion cancelled');
				}
			},
			handleCurrentChange(newPage) {
				this.page = newPage
				this.$store.commit(SET_COMMENT_QUERY_PAGE_NUM, newPage)
				this.$store.commit(SET_PARENT_COMMENT_ID, -1)
				this.$store.dispatch('getCommentList')
			},
			init(id,page) {
				//重置评论表单位置
				this.$store.commit(SET_PARENT_COMMENT_ID, -1)
				this.$store.commit(SET_COMMENT_QUERY_PAGE, 1)
				this.$store.commit(SET_COMMENT_QUERY_BLOG_ID, id)
				this.$store.commit(SET_COMMENT_QUERY_PAGE_NUM, this.commentQuery.pageNum)
				this.$store.dispatch('getCommentList')
			},
			formatTime(isoString) {
				const date = new Date(isoString); 
				const options = { 
					year: 'numeric', 
					month: 'long', 
					day: 'numeric', 
					hour: 'numeric', 
					minute: 'numeric', 
					hour12: true,
					timeZone: 'Asia/Shanghai' 
				};
				return new Intl.DateTimeFormat('en-US', options).format(date).replace(',', '');
			},
			formatDate(isoString) {
				const date = new Date(isoString);
				const options = { year: 'numeric', month: 'long', day: 'numeric' };
				return date.toLocaleDateString('en-US', options);
			},
			getBlog(id = this.blogId) {
				//密码保护的文章，需要发送密码验证通过后保存在localStorage的Token
				const blogToken = window.localStorage.getItem(`blog${id}`)
				//如果有则发送博主身份Token
				const adminToken = window.sessionStorage.getItem('adminToken')
				const token = adminToken ? adminToken : (blogToken ? blogToken : '')
				getBlogById(token, id).then(res => {
					if (res.code === 200) {
						this.blog = res.data
						if(this.siteInfo.webTitleSuffix){
							document.title = this.blog.title + this.siteInfo.webTitleSuffix
						}else{
							document.title = this.blog.title
						}
						// if (this.$route.path !== `/${this.blog.title}`) {
						// 	this.$router.replace({ path: `/${this.blog.title}` });
						// }
						//v-html渲染完毕后，渲染代码块样式
						this.$nextTick(() => {
							Prism.highlightAll()
							//将文章渲染完成状态置为 true
							this.$store.commit(SET_IS_BLOG_RENDER_COMPLETE, true)
						})
					} else {
						this.msgError(res.msg)
					}
				}).catch(() => {
					this.msgError("请求失败")
				})
			},
			changeFocusMode() {
				this.$store.commit(SET_FOCUS_MODE, !this.focusMode)
			},
			isValidEmail(email) {
				const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
				return regex.test(email);
			},
			async postForm() {
				const adminToken = window.localStorage.getItem('adminToken')
				this.commentForm.rate = ((this.ratePrice+this.rateQuality+this.rateService)/3).toFixed(1)
				this.commentForm.pros = this.prosField.map(item => item.value).join(",")
				this.commentForm.cons = this.consField.map(item => item.value).join(",")
				if (adminToken) {
					//博主登录后，localStorage中会存储token，在后端设置属性，可以不校验昵称、邮箱
					if (this.commentForm.content === '' || this.commentForm.content.length > 250) {
						return this.$notify({
							title: '评论失败',
							message: '评论内容有误',
							type: 'warning'
						})
					} else {
						return this.$store.dispatch('submitCommentForm', adminToken)
					}
				}
				const blogToken = window.localStorage.getItem(`blog${this.commentQuery.blogId}`)
				this.$refs.formRef.validate(async valid => {
					if (!valid || this.commentForm.content === '' || this.commentForm.content.length > 250) {
						this.$notify({
							title: '评论失败',
							message: '请正确填写评论',
							type: 'warning'
						})
					}else if(!valid || this.commentForm.nickname === '' ){
						this.$notify({
							title: '评论失败',
							message: '请填写昵称',
							type: 'warning'
						})
					} else if(!valid || this.commentForm.email === '' || !this.isValidEmail(this.commentForm.email)){
						this.$notify({
							title: '评论失败',
							message: '请正确填写邮箱',
							type: 'warning'
						})
					}else{
						try {
							await this.$store.dispatch('submitCommentForm', blogToken ? blogToken : '');
							await this.getBlog(this.id);
							await this.init(this.id, 1);
						} catch (error) {
							console.error("提交评论失败:", error);
						}
					}
				})
			}
		}
	}
</script>

<style scoped>
	.rowContainer{
		width: 100%;
		margin-right: auto;
		margin-left: auto;
	}
	@media (min-width: 1400px) {
		.rowContainer {
			max-width: 1200px !important;
		}
	}
	@media (min-width: 1200px) {
		.rowContainer {
			max-width: 1140px;
		}
	}
	@media (min-width: 992px) {
		.rowContainer{
			max-width: 960px;
		}
	}
	@media (min-width: 768px) {
		.rowContainer{
			max-width: 720px;
		}
	}
	@media (min-width: 576px) {
		.rowContainer{
			max-width: 540px;
		}
	}
	@media (min-width: 992px) and (max-width: 1400px) {
		.rowContainer{
			max-width: 1320px;
		}
	}
	@media (max-width: 520px) {
		.rtrs-rating-category /deep/ .el-rate__icon{
			margin-right: 0 !important;
		}
		.rtrs-rating-category /deep/ label{
			min-width: 0 !important;
			margin-right: 0 !important;
		}
		.rtrs-rating-overall /deep/ .el-rate__icon{
			margin-right: 0 !important;
		}
	}	
	.site {
		display: flex;
		min-height: 100vh; /* 没有元素时，也把页面撑开至100% */
		flex-direction: column;
		
	}
	.el-divider {
		margin: 1rem 0 !important;
	}

	h5::before, h6::before {
		display: block;
		content: " ";
		height: 55px;
		/* margin-top: -5px; */
		/* visibility: hidden; */
	}
	.site-content {
		position: relative;
		background-color: #fff;
		z-index: 1;
		transition: allease 0.31s;
	}
	.content-area {
		padding-top: 100px;
		padding-bottom: 100px;
	}
	.container-custom {
		max-width: 1548px;
		margin: 0 auto;
		padding-left: 12px;
		padding-right: 12px;
	}
	.row {
		--bs-gutter-x: 1.5rem;
		--bs-gutter-y: 0;
		display: flex;
		flex-wrap: wrap;
		margin-top: calc(-1* var(--bs-gutter-y));
		margin-right: calc(-.5* var(--bs-gutter-x));
		margin-left: calc(-.5* var(--bs-gutter-x));
	}
	@media (min-width: 1200px) {
		.col-xl-8 {
			flex: 0 0 auto;
			width: 66.66666667%;
			padding-right: 10px;
		}
		.col-xl-4 {
			flex: 0 0 auto;
			width: 33.33333333%;
			padding-left: 10px;
		}
	}
	@media (max-width: 1200px) {
		.col-xl-8 {
			flex: 0 0 auto;
			width: 100%;
		}
		.col-xl-4 {
			flex: 0 0 auto;
			width: 100%;
		}
		.m-search{
			width: 100% !important;
		}
	}
	.row > * {
		--bs-gutter-x: 1.5rem;
    	--bs-gutter-y: 0;
		/* flex-shrink: 0; */
		/* width: 100%; */
		max-width: 100%;
		padding-right: calc(var(--bs-gutter-x)* .5);
		padding-left: calc(var(--bs-gutter-x)* .5);
		margin-top: var(--bs-gutter-y);
	}
	.rt-sidebar-sapcer {
		margin-right: 6px;
	}
	@media (max-width: 1199px) {
		.rt-sidebar-sapcer {
			margin-right: 0;
			display: inherit;
		}
	}
	.entry-thumbnail-area {
		border: 7px #ccc solid;
		border-radius: 15px;
		text-align: center;
		position: relative;
		margin-bottom: 40px;
	}
	.entry-thumbnail-area img {
		border-radius: 10px;
	}
	.entry-header .entry-categories {
		margin-bottom: 10px;
	}

	.entry-categories {
		display: inline-flex;
		flex-wrap: wrap;
		gap: 5px;
	}
	a {
		color: #2c3e50;
	}
	.entry-categories .category-style{
		background-color: #2c3e50;
	}
	.entry-categories .category-style {
		display: inline-flex;
		font-size: 14px;
		color: #fff;
		border-radius: 4px;
		padding: 8px 15px 8px;
		font-weight: 500;
		letter-spacing: 0.7px;
		line-height: 1;
		transition: allease 0.31s;
	}
	.category-style span {
		font-size: 9px;
	}
	.entry-header .entry-title {
		font-size: 28px;
		margin-bottom: 5px;
		line-height: 1.4;
		transition: allease 0.31s;
	}
	h1 {
		font-style: normal;
		font-family: 'Inter', sans-serif;
    	font-weight: 600;
		margin: 0 0 20px 0;
    	color: #161f38;
	}
	.entry-header ul.entry-meta {
		padding: 0px;
		margin: 0 0 20px;
		list-style: none;
		display: inline-flex;
		align-items: center;
		flex-wrap: wrap;
	}
	.entry-header ul.entry-meta li {
		display: inline-block;
		color: #777777;
		font-size: 14px;
		font-weight: 500;
		margin-right: 12px;
		position: relative;
		letter-spacing: 0.2px;
		text-transform: capitalize;
		transition: allease 0.31s;
	}
	.entry-header ul.entry-meta li.item-author a {
		color: #161f38;	
		font-weight: 600;
	}
	.entry-header ul.entry-meta li .view-number {
		color: #161f38;
		font-weight: 600;
		transition: allease 0.31s;
	}
	.entry-content {
		counter-reset: footnotes;
		font-family: 'Inter', sans-serif !important;
		font-size: 16px;
		font-weight: normal;
		font-style: normal;
		color: #6c6f72;
		box-sizing: border-box;
	}
	/* .entry-content ::v-deep {
		p {
			margin: 0 0 20px 0;
			line-height: 28px;
			
		}
		img {
			width: 100% !important;
			height: auto;
		}
	} */
	.entry-content /deep/ p {
		margin: 0 0 20px 0;
		line-height: 28px;
	}
	.entry-content /deep/ p img {
		width: 100% !important;
		height: auto;
	}
	.entry-content /deep/ img {
		width: 100% !important;
		height: auto;
	}
	.entry-footer .entry-footer-meta {
		overflow: hidden;
		margin-top: 30px;
		margin-bottom: 50px;
		padding-top: 30px;
		padding-bottom: 30px;
		display: flex;
		justify-content: space-between;
		border-top: 1px solid #eaeaea;
		border-bottom: 1px solid #eaeaea;
		transition: allease 0.31s;
	}
	.entry-footer .meta-title {
		font-size: 18px;
		margin-bottom: 14px;
	}
	h4 {
		line-height: 28px;
		font-style: normal;
		font-family: 'Inter', sans-serif;
    	font-weight: 600;
	}
	.post-share .share-links a.facebook-f-share-button {
		background: #1559c2;
	}
	.share-links a svg{
		width: 16px;
		height: 16px;
	}
	.post-share .share-links a {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 40px;
		height: 40px;
		overflow: hidden;
		color: #ffffff;
		font-size: 15px;
		background: #646464;
		position: relative;
		transition: allease 0.31s;
		border-radius: 50%;
		margin-bottom: 5px;
		margin-right: 8px;
	}
	.post-share .share-links a.x-twitter-share-button {
		background: #1ea9e9;
	}
	.post-share .share-links a.youtube-share-button {
		background: #ed1d25;
	}
	.post-share .share-links a.linkedin-in-share-button {
		background: #238cc8;
	}
	.post-share .share-links a.pinterest-p-share-button {
		background: #bd081c;
	}
	.rtrs-review-wrap {
		display: flex;
		flex-direction: column;
		background-color: transparent !important;
		margin-top: 50px !important;
		margin: auto;
		background-color: #fff;
		border-radius: 4px;
		width: auto;
	}
	.rtrs-summary-3 {
		order: 1;
	}
	.rtrs-summary-3 .rtrs-rating-summary {
		display: grid;
		gap: 20px;
		grid-template-columns: repeat(3, 1fr);
	}
	.rtrs-summary-3 .grid-span-2 {
		grid-column: 1 / span 2;
	}
	.rtrs-summary-3 .rtrs-rating-item {
		border: 1px solid #eaeaea;
		border-radius: 6px;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}
	.rtrs-review-wrap .rtrs-summary-3 .rtrs-rating-item{
		border-radius: 10px;
		border: 1px solid #eaeaea;
		overflow: hidden;
		transition: allease 0.31s;
	}
	.rtrs-summary-3 .rtrs-rating-category {
		margin: 0;
		padding: 0;
	}
	.rtrs-review-wrap ul {
		border-bottom: none;
	}
	ul {
		list-style: disc inside none;
		margin: 0 0 20px 0;
	}
	.rtrs-summary-3 .rtrs-rating-category li {
		align-items: center;
		display: flex;
		padding: 10px 20px;
	}
	.rtrs-review-wrap .rtrs-summary-3 .rtrs-rating-category label {
		font-size: 16px;
		min-width: 100px;
		color: #161f38;
		transition: allease 0.31s;
	}
	.rtrs-summary-3 .rtrs-rating-category label {
		color: #111;
		flex: 1;
		font-weight: 500;
		margin-right: 20px;
	}
	label {
		display: inline-block;
	}
	.rtrs-summary-3 .rtrs-rating-overall {
		padding: 30px 10px;
		text-align: center;
	}
	.rtrs-summary-3 .rtrs-rating-overall .rating-percent {
		color: #161f38;
		transition: allease 0.31s;
		margin-bottom: 8px;
		font-size: 40px;
		font-weight: 700;
	}
	.rtrs-summary-3 .rtrs-rating-overall .rating-text{
		color: #161f38;
		transition: allease 0.31s;
		font-size: 14px;
		font-weight: 600;
		margin-bottom: 4px;
	}
	.rtrs-summary-3 .rtrs-rating-overall p {
		color: #161f38;
		transition: allease 0.31s;
		font-size: 14px;
		margin: 0;
	}
	.rtrs-review-wrap .rtrs-sorting-bar{
		background-color: #ffffff !important;
		box-shadow: 0px 0px 35px rgb(0 0 0 / 5%);
		border-radius: 10px;
		transition: allease 0.31s;
	}
	.rtrs-review-wrap .rtrs-sorting-bar .rtrs-sorting-select label, .rtrs-review-wrap .rtrs-sorting-bar .rtrs-sorting-title {
		color: #161f38;
		transition: allease 0.31s;
	}
	.rtrs-review-wrap .rtrs-sorting-bar .rtrs-sorting-select label svg{
		width:12px;
		height: 12px;
		margin-right: 5px;
	}
	.rtrs-sorting-bar .rtrs-sorting-title {
		color: #444;
		font-size: 16px;
		font-weight: 400;
		margin: 0;
	}
	h3 {
		font-size: 28px;
		line-height: 36px;
		font-style: normal;
		font-family: 'Inter', sans-serif;
	}
	.rtrs-sorting-bar {
		order: 2;
	}
	.rtrs-sorting-bar {
		align-items: center;
		background-color: #fafafa;
		border-radius: 4px;
		display: flex;
		justify-content: space-between;
		margin-bottom: 20px;
		margin-top: 20px;
		padding: 5px 22px;
	}
	.rtrs-sorting-bar .rtrs-sorting-select {
		display: flex;
		gap: 5px;
	}
	.rtrs-sorting-bar .rtrs-sorting-select label {
		color: #444;
		margin-right: 8px;
	}
	label {
		display: inline-block;
	}
	.rtrs-sorting-bar .rtrs-sorting-select select {
		background-color: #fff;
		border: none;
		border-radius: 3px;
		box-shadow: 0 3px 8px 0 hsla(0, 0%, 75%, .27);
		color: #969696;
		cursor: pointer;
		font-size: 14px;
		margin-bottom: 6px;
		margin-top: 5px;
		padding: 10px 25px 9px 15px;
	}
	.rtrs-sort-filter {
		margin-right: 10px;
	}
	.rtrs_review_filter {
		width: auto;
	}
	select {
		appearance: none;
		background-size: 10px;
		background-image: url(../../assets/images/select-arrow.svg) !important;
		background-repeat: no-repeat;
		background-position: 95%;
		border: 1px solid var(--revie-border-color);
		transition: allease 0.31s;
	}
	button, select {
		text-transform: none;
	}

	button, input, optgroup, select, textarea {
		color: inherit;
		font: inherit;
		margin: 0;
	}
	select {
		word-wrap: normal;
	}
	.rtrs-review-wrap .rtrs-sorting-bar .rtrs-sorting-select select {
		background-color: transparent;
		box-shadow: unset;
	}
	#respond {
		order: 3;
	}
	.rtrs-review-wrap .rtrs-review-form{
		background-color: #ffffff !important;
		box-shadow: 0px 0px 35px rgb(0 0 0 / 5%);
		border-radius: 10px;
		transition: allease 0.31s;
	}
	.rtrs-review-form {
		margin-top: 0 !important;
	}
	.rtrs-review-form {
		background-color: #f8f8f8;
		border-radius: 4px;
		margin-top: 70px;
		padding: 30px;
	}
	.rtrs-review-wrap .rtrs-review-form .rtrs-form-title{
		color: #161f38;
		transition: allease 0.31s;
	}
	.rtrs-review-form .rtrs-form-title {
		color: #000;
		font-size: 22px;
		font-weight: 600;
		margin: 0 0 12px;
	}
	h2 {
		font-size: 36px;
		line-height: 42px;
		font-style: normal;
		font-family: 'Inter', sans-serif;
	}
	.rtrs-review-form .rtrs-form-group {
		margin-bottom: 10px;
	}
	.rtrs-review-wrap .rtrs-review-form .rtrs-form-group .rtrs-form-control {
		background-color: #ffffff;
		border: 1px solid #eaeaea !important;
		color: #6c6f72;
		border-radius: 6px;
		padding: 5px 10px;
	}
	.rtrs-review-form .rtrs-form-group .rtrs-form-control {
		background-color: #fff;
		border: 1px solid #e1e1e1;
		border-radius: 4px;
		color: #111;
		font-size: 15px;
		padding: 10px 20px;
		width: 100%;
	}
	.rtrs-review-form .rtrs-form-group input {
		height: 48px;
	}
	.rtrs-form-box .rtrs-rating-category{
		padding: 0 !important;
	}
	.rtrs-review-form .rtrs-rating-category {
		display: grid;
		grid-template-columns: repeat(2, 270px);
		list-style: none;
		margin: 27px 0 0 5px;
		padding: 0;
	}

	.rtrs-review-wrap ul {
		border-bottom: none;
	}
	.rtrs-review-form .rtrs-rating-category li {
		display: flex;
		margin-bottom: 10px;
	}
	.rtrs-review-wrap .rtrs-review-form .rtrs-rating-category .rtrs-category-text {
		color: #161f38;
		transition: allease 0.31s;
	}
	.rtrs-review-wrap .rtrs-review-form .rtrs-rating-category .rtrs-category-text {
		min-width: 110px;
	}
	.rtrs-review-form .rtrs-rating-category .rtrs-category-text {
		color: #000;
		font-size: 17px;
		font-weight: 500;
		min-width: 80px;
	}
	.rtrs-rating-container {
		
	}
	.rtrs-review-form .rtrs-form-group {
		margin-bottom: 10px;
	}
	.rtrs-review-wrap .rtrs-review-form .rtrs-feedback-input{
		background-color: transparent;
		border: 1px solid #eaeaea;
		border-radius: 6px;
	}
	.rtrs-review-form .rtrs-feedback-input {
		background-color: #fff;
		border: 1px solid #e1e1e1;
		border-radius: 4px;
		display: flex;
	}
	.rtrs-review-form .rtrs-feedback-input .rtrs-input-item {
		border-right: 1px solid #ebebeb;
		flex: 1;
		padding: 25px 30px;
	}
	.rtrs-review-form .rtrs-feedback-input .rtrs-input-title {
		margin: 0 0 16px;
	}
	.rtrs-review-form .rtrs-feedback-input .rtrs-input-title .item-icon {
		background-color: #24ecbb;
		border-radius: 4px;
		color: #fff;
		display: inline-block;
		font-size: 18px;
		height: 28px;
		line-height: 28px;
		margin-right: 12px;
		text-align: center;
		width: 29px;
	}
	.item-icon svg{
		width:16px;
		height:16px;
	}
	.rtrs-review-wrap .rtrs-review-form .rtrs-feedback-input .rtrs-input-title .item-text {
		color: #161f38;
	}

	.rtrs-review-form .rtrs-feedback-input .rtrs-input-title .item-text {
		color: #010101;
		font-size: 18px;
		font-weight: 500;
	}

	.rtrs-review-form .rtrs-feedback-input .rtrs-field-add {
		color: #646464;
		cursor: pointer;
		display: inline-block;
		font-size: 14px;
		transition: all .3sease-in-out;
	}
	.rtrs-field-add svg{
		width: 10px;
		height:10px;
		margin-right: 5px;
	}
	.rtrs-review-wrap .rtrs-review-form .rtrs-feedback-input .rtrs-input-item {
		border-right: 1px solid #eaeaea;
	}
	.rtrs-review-form .rtrs-feedback-input .rtrs-input-title .unlike-icon {
		background-color: #ff4242;
	}
	.rtrs-review-form .rtrs-feedback-input .rtrs-input-filed {
		padding-right: 30px;
		position: relative;
	}
	.rtrs-review-form .rtrs-feedback-input .rtrs-remove-btn {
		background: #901818;
		border-radius: 50%;
		color: #fff;
		cursor: pointer;
		display: inline-block;
		font-size: 18px;
		height: 20px;
		line-height: 18px;
		position: absolute;
		right: 0;
		text-align: center;
		top: 10px;
		transform: rotate(45deg);
		transition: all .3sease-in-out;
		width: 20px;
	}
	.form-control {
		display: block;
		width: 100%;
		padding: .375rem .75rem;
		font-size: 1rem;
		font-weight: 400;
		line-height: 1.5;
		color: #212529;
		background-color: #fff;
		background-clip: padding-box;
		border: 1px solid #ced4da;
		-webkit-appearance: none;
		-moz-appearance: none;
		appearance: none;
		border-radius: .25rem;
		transition: border-color .15sease-in-out, box-shadow .15sease-in-out;
	}
	.rtrs-review-form .rtrs-feedback-input .form-control {
		background-color: #fff;
		border: 1px solid #ebebeb;
		border-radius: 4px;
		font-size: 16px;
		height: 40px;
		margin-bottom: 10px;
		padding: 5px 20px;
		width: 100%;
	}
	.rtrs-review-wrap .rtrs-review-form .rtrs-feedback-input .form-control {
		background-color: transparent;
		border: 1px solid #eaeaea;
		border-radius: 6px;
	}
	#respond form input.form-control {
		height: 50px;
	}
	#respond form .form-control {
		padding: 10px 20px;
	}
	#respond form .form-control {
		background: #ffffff;
		border-radius: 5px;
		color: #161f38;
		font-size: 15px;
		font-weight: 400;
		margin-right: 20px;
		box-shadow: none;
		transition: allease 0.31s;
	}
	.rtrs-review-wrap .rtrs-review-form .rtrs-form-group .rtrs-submit-btn {
		background-color: #2c3e50 !important;
	}
	.rtrs-review-wrap .rtrs-review-form .rtrs-form-group .rtrs-submit-btn {
		border-radius: 6px !important;
		font-size: 18px !important;
		font-weight: 500;
		letter-spacing: 0.6px;
		padding: 12px 26px !important;
		height: inherit !important;
		margin-top: 20px;
		line-height: 1.5;
	}
	.rtrs-review-form .rtrs-form-group .rtrs-submit-btn {
		float: none !important;
	}
	.rtrs-review-form .rtrs-form-group .rtrs-submit-btn {
		background-color: #444;
		border: none;
		border-radius: 4px;
		color: #fff;
		cursor: pointer;
		font-size: 14px;
		font-weight: 700;
		outline: none;
		padding: 10px 24px;
		transition: all .3s ease-in-out;
	}

	.rtrs-review-form .rtrs-form-group input {
		height: 48px;
	}
	.rtrs-review-box {
		order: 4;
	}
	.rtrs-review-box .rtrs-review-list {
		list-style: none;
		margin: 0;
		padding: 0;
	}

	ul.rtrs-review-list {
		display: flex;
		flex-direction: column-reverse;
	}
	.rtrs-review-wrap ul {
		border-bottom: none;
	}
	.rtrs-review-box .rtrs-main-review {
		display: block !important;
	}

	.rtrs-review-box .rtrs-main-review {
		margin-bottom: 20px;
	}
	.rtrs-review-wrap .rtrs-review-box .rtrs-each-review {
		background-color: #ffffff !important;
		box-shadow: 0px 0px 35px rgb(0 0 0 / 5%);
		border-radius: 10px;
		transition: all ease 0.31s;
	}
	.rtrs-review-box .rtrs-each-review {
		align-items: flex-start;
		background-color: #f8f8f8;
		display: flex;
		padding: 30px 25px 20px;
	}
	.rtrs-review-box .rtrs-review-list {
		list-style: none;
	}
	.rtrs-review-box .rtrs-review-imgholder {
		margin-right: 15px;
	}
	.rtrs-review-box .rtrs-review-imgholder img {
		border-radius: 50%;
	}
	.rtrs-review-box .rtrs-review-body {
		flex: 1;
		position: relative;
	}
	.rtrs-review-box .rtrs-review-body .rtrs-review-meta {
		list-style: none;
		margin: 0;
		padding: 0;
	}
	.rtrs-review-box .rtrs-each-review .rtrs-review-body .rtrs-review-meta .rtrs-author-link, .rtrs-review-box .rtrs-each-review .rtrs-review-body .rtrs-review-meta .rtrs-review-date, .rtrs-review-box .rtrs-each-review .rtrs-review-body .rtrs-review-meta .rtrs-author-social label, .rtrs-review-box .rtrs-each-review .rtrs-review-body .rtrs-action-area button i:before, .rtrs-review-box .rtrs-each-review .rtrs-review-body .rtrs-review-meta .rtrs-review-date i:before, .rtrs-review-box .rtrs-each-review .rtrs-review-body .rtrs-review-meta .rtrs-author-social label i:before, .rtrs-review-box .rtrs-each-review .rtrs-review-body .rtrs-review-meta .rtrs-author-social a{
		color: #777777;
    	transition: all ease 0.31s;
	}
	.rtrs-review-box .rtrs-review-body .rtrs-review-meta .rtrs-author-link {
		font-size: 14px;
	}

	.rtrs-review-box .rtrs-review-body .rtrs-review-meta li {
		display: inline-block;
		margin-bottom: 10px;
		margin-right: 10px;
	}
	.rtrs-review-box .rtrs-review-body .rtrs-review-meta .rtrs-review-date {
		color: #6d6d6d;
		font-size: 14px;
	}
	
	.rtrs-review-box .rtrs-review-body .rtrs-review-meta li:last-child {
		margin-right: 0;
	}
	.rtrs-review-box .rtrs-each-review .rtrs-review-body .rtrs-review-meta .rtrs-review-rating {
		color: #ffcd30 !important;
		font-size: 14px;
		display: inline-flex;
		column-gap: 3px;
	}
	.rtrs-review-box .rtrs-each-review .rtrs-review-body p {
		color: #6c6f72;
		line-height: 28px;
		transition: all ease 0.31s;
	}

	.rtrs-review-box .rtrs-review-body p {
		color: #646464;
		font-size: 16px;
		line-height: 24px;
		margin: 0 0 18px;
	}
	small {
		font-size: 80%;
	}
	.rtrs-review-box .rtrs-review-body .rtrs-action-area {
		margin-bottom: 15px;
		margin-left: -6px;
	}

	.mx-auto {
		margin-right: auto !important;
		margin-left: auto !important;
	}
	
	
	img {
		max-width: 100%;
		height: auto;
	}
	h1, h2, h3, h4, h5, h6 {
		font-family: "Inter", sans-serif;
		margin: 0 0 20px 0;
		color: #161f38;
		transition: allease 0.31s;
	}
	.rtrs-review-form .rtrs-feedback-input .rtrs-remove-btn:hover {
		background-color: #0028ff;
		color: #fff;
	}
	.rtrs-review-box .rtrs-review-body .rtrs-review-feedback {
		display: flex;
		margin-top: 24px;
	}
	.rtrs-review-box .rtrs-review-body .rtrs-review-feedback .rtrs-feedback-box {
		flex: 1;
	}
	.rtrs-review-box .rtrs-review-body .rtrs-review-feedback .rtrs-feedback-title {
		margin: 0 0 14px;
	}
	.rtrs-review-box .rtrs-review-body .rtrs-review-feedback .rtrs-feedback-title .item-icon {
		background-color: #24ecbb;
		border-radius: 4px;
		color: #fff;
		display: inline-block;
		font-size: 18px;
		height: 28px;
		line-height: 28px;
		margin-right: 12px;
		width: 29px;
	}
	.rtrs-review-box .rtrs-review-body .rtrs-review-feedback .rtrs-feedback-title .item-text {
		color: #010101;
		font-size: 15px;
		font-weight: 600;
	}
	.rtrs-review-box .rtrs-review-body .rtrs-review-feedback .rtrs-feedback-list {
		list-style: none;
		margin-bottom: 10px;
		padding: 0;
	}

	.rtrs-review-wrap ul {
		border-bottom: none;
	}
	.rtrs-review-box .rtrs-review-body .rtrs-review-feedback .rtrs-feedback-list li {
		display: block !important;
	}

	.rtrs-review-box .rtrs-review-body .rtrs-review-feedback .rtrs-feedback-list li {
		color: #646464;
		font-size: 15px;
		margin-bottom: 4px;
		position: relative;
	}
	.rtrs-review-box .rtrs-review-body .rtrs-review-feedback .rtrs-feedback-list li svg {
		width: 15px;
		height: 15px;
		margin-right: 10px;
		font-weight: bold;
	}
	.rtrs-review-box .rtrs-review-body .rtrs-review-feedback .rtrs-feedback-title .unlike-icon {
		background-color: #ff4242;
	}
	.rtrs-feedback-title .item-icon svg{
		width:18px;
		height: 18px;
		margin-left: 5px;
		margin-top: 4px;
	}
	.site /deep/ .el-dialog__header{
		display: none !important;
		padding: 0 !important;
	}
	.site /deep/ .el-dialog__body{
		padding: 30px 40px !important;
		border-radius: 10px !important;
	}
	.site /deep/ .el-dialog{
		border-radius: 10px !important;
	}
</style>